"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExampleResultPaginationNextPrev = void 0;
const react_1 = __importDefault(require("react"));
const ExampleResultPaginationNextPrev = (props) => {
    return (react_1.default.createElement("nav", { className: "rs__pagination__nav" },
        props.hasPreviousPage && (react_1.default.createElement("a", { className: "rs__pagination__prev-link", rel: "prev", onClick: props.handlePreviousPage, href: props.buildPagePath(props.actualCurrentPage - 1) }, "Prev")),
        props.hasNextPage && (react_1.default.createElement("a", { className: "rs__pagination__next-link", rel: "next", onClick: props.handleNextPage, href: props.buildPagePath(props.actualCurrentPage + 1) }, "Next"))));
};
exports.ExampleResultPaginationNextPrev = ExampleResultPaginationNextPrev;
//# sourceMappingURL=ExampleResultPaginationNextPrev.js.map